import { SaleTranslate } from './saleTranslate.model';

const saleTranslateEN: SaleTranslate = {
  section: {
    title: 'Sales',
    registerButton: 'Register sale',
    cancelButton: 'Cancel',
    duplicateButton: 'Duplicate',
    emptyState: 'No sales registered',
    cancelConfirmation: {
      title: 'Cancel sale',
      description:
        'Are you sure you want to cancel this sale? This action cannot be undone.',
      confirm: 'Yes, cancel',
    },
  },
  paymentMethod: {
    PIX: 'PIX',
    CASH: 'Cash',
    CREDIT_CARD: 'Credit Card',
    DEBIT_CARD: 'Debit Card',
    BANK_TRANSFER: 'Bank Transfer',
    BOLETO: 'Boleto',
    OTHER: 'Other',
  },
  installmentStatus: {
    PENDING: 'Pending',
    PAID: 'Paid',
    OVERDUE: 'Overdue',
  },
  installments: {
    toggle: 'Installments ({{count}}x)',
    row: {
      number: 'Installment {{current}}/{{total}}',
      markPaid: 'Mark as paid',
      receipt: 'Receipt',
    },
    receipt: {
      error: 'Could not download the receipt',
    },
  },
  registerModal: {
    title: 'Register sale',
    sections: {
      services: 'Services',
      packages: 'Packages',
    },
    fields: {
      servicesPlaceholder: 'Select services',
      packagesPlaceholder: 'Select packages',
      servicesSearchPlaceholder: 'Search service',
      servicesNoResults: 'No service found',
      packagesSearchPlaceholder: 'Search package',
      packagesNoResults: 'No package found',
      quantityPlaceholder: 'Qty',
      totalPrice: 'Total ($)',
      paymentMethod: 'Payment method',
      installmentsCount: 'Number of installments',
      firstDueDate: '1st installment due date',
      soldAt: 'Sale date',
      notes: 'Notes',
    },
    errors: {
      itemsMin: 'Select at least one service or package',
      totalPositive: 'Total must be greater than zero',
      totalInvalidType: 'Total must be a number',
      installmentsInvalidType: 'Number of installments must be a number',
      installmentsMin: 'Minimum 1 installment',
      installmentsMax: 'Maximum 24 installments',
      paymentMethodRequired: 'Payment method is required',
      firstDueDateRequired:
        '1st installment due date is required for installment plans',
      firstDueDateInvalid: 'Invalid date',
      soldAtRequired: 'Sale date is required',
      soldAtInvalid: 'Invalid sale date',
      installmentsSumMismatch:
        'The sum of installments must equal the total amount',
      installmentsDateInvalid: 'One of the installment dates is invalid',
    },
    installments: {
      customizeLabel: 'Customize installments',
      amount: 'Amount',
      dueDate: 'Due date',
      sum: 'Installments total',
    },
    actions: {
      cancel: 'Cancel',
      register: 'Register sale',
    },
    aria: {
      removeService: 'Remove service',
      removePackage: 'Remove package',
    },
  },
  metrics: {
    tabLabel: 'Sales',
    kpi: {
      revenue: {
        label: 'Monthly revenue',
        subtext: '{{delta}} vs previous period',
      },
      ticket: {
        label: 'Average ticket',
      },
      count: {
        label: 'Total sales',
      },
      overdue: {
        label: 'Overdue payments',
        zero: 'All settled',
        tooltip:
          'Total overdue installments in the period, regardless of applied filters',
        infoAria: 'About the overdue calculation',
      },
      pending: {
        label: 'To receive (month)',
      },
      received: {
        label: 'Received (month)',
      },
    },
    drawer: {
      title: 'Filters',
      paymentMethod: 'Payment method',
      package: 'Package',
      service: 'Service',
      year: 'Year',
      apply: 'Apply filters',
      clear: 'Clear filters',
    },
    slider: {
      aria: 'Navigate months',
      previous: 'Previous month',
      next: 'Next month',
    },
    filtersAria: 'Open filters',
  },
};

export default saleTranslateEN;
